import { memo } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { logoUSKidsHorizontal } from '@/assets/images';
import { Stack } from '@/components/layout';
import { Image, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import NotificationButton from '@/features/guardian/components/notification-button';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

export type FamilyHeaderProps = {
  onNotificationPress?: () => void;
  hasUnreadNotification?: boolean;
};

const TABLET_TITLE = STRINGS.common.navigation.tabPlayers;
const TABLET_HEADER_HEIGHT = 64;
const TABLET_LOGO_WIDTH = 174;
const TABLET_LOGO_HEIGHT = 29;
const TABLET_SIDE_SLOT_WIDTH = 174;

function FamilyHeader({ onNotificationPress, hasUnreadNotification = true }: FamilyHeaderProps) {
  const { isTablet, scale } = useScaling();
  const insets = useSafeAreaInsets();
  const styles = useStyles();

  if (isTablet) {
    return (
      <Stack
        direction="row"
        align="center"
        justify="space-between"
        backgroundColor={colors['0']}
        height={insets.top + scale(TABLET_HEADER_HEIGHT)}
        paddingTop={insets.top}
        paddingX={scale(20)}>
        <Stack width={scale(TABLET_SIDE_SLOT_WIDTH)} direction="row" align="center">
          <Image
            source={logoUSKidsHorizontal}
            width={scale(TABLET_LOGO_WIDTH)}
            height={scale(TABLET_LOGO_HEIGHT)}
            resizeMode="contain"
          />
        </Stack>

        <Stack flex={1} align="center" justify="center">
          <Text
            numberOfLines={1}
            variant="Font Guardian App/Body/Body 16 Bold"
            style={styles.title}>
            {TABLET_TITLE}
          </Text>
        </Stack>

        <Stack
          width={scale(TABLET_SIDE_SLOT_WIDTH)}
          direction="row"
          align="center"
          justify="flex-end">
          <NotificationButton
            hasUnreadNotification={hasUnreadNotification}
            onPress={onNotificationPress}
          />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      align="center"
      justify="space-between"
      backgroundColor={guardianColors['1']}
      paddingTop={insets.top + scale(8)}
      paddingBottom={scale(8)}
      paddingX={scale(20)}>
      <Text variant="Font Guardian App/Heading/Heading 20" style={styles.title}>
        {STRINGS.guardian.kids.myFamily}
      </Text>
      <NotificationButton
        hasUnreadNotification={hasUnreadNotification}
        onPress={onNotificationPress}
      />
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  title: {
    color: guardianColors['10'],
    textAlign: 'center',
  },
}));

export default memo(FamilyHeader);
